/**
 * Persists enquiry list API responses in localStorage to avoid repeat requests
 * for the same filters / pagination / user.
 */

import { stableStringify } from './stableStringify';

const STORAGE_KEY = 'vacspl_enquiries_list_cache';

/**
 * Serialize list request params so cache hits are consistent.
 */
export function buildEnquiriesListCacheKey(filters, sort, page, rowsPerPage, userId = '') {
  return stableStringify({
    filters: filters || {},
    sort: sort || {},
    page,
    rowsPerPage,
    userId: userId || '',
  });
}

function readStore() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return typeof parsed === 'object' && parsed !== null ? parsed : {};
  } catch {
    return {};
  }
}

function writeStore(map) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
  } catch (e) {
    console.warn('enquiries list cache: write failed', e);
  }
}

/**
 * @returns {{ data: Array, total: number, page: number, rowsPerPage: number } | null}
 */
export function getCachedEnquiriesList(cacheKey) {
  const map = readStore();
  const entry = map[cacheKey];
  if (!entry || !Array.isArray(entry.data)) return null;
  return {
    data: entry.data,
    total: typeof entry.total === 'number' ? entry.total : 0,
    page: entry.page,
    rowsPerPage: entry.rowsPerPage,
  };
}

export function setCachedEnquiriesList(cacheKey, response) {
  const map = readStore();
  map[cacheKey] = {
    data: response.data,
    total: response.total,
    page: response.page,
    rowsPerPage: response.rowsPerPage,
  };
  writeStore(map);
}

export function clearEnquiriesListCache() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}
